export default [
  {
    name: 'busd_bnbmainnet',
    displayName: 'Binance USD',
    decimals: 8,
    ticker: 'BUSDBNB',
    displayTicker: 'BUSD',
    assetId: 'BUSD-BD1',
    tokenType: 'BEP2',
    info: {
      description:
        'Stablecoin, issued in partnership with Binance. BUSD is 100% backed by U.S. dollars held in FDIC-insured U.S. banks.',
      twitter: 'https://twitter.com/paxosglobal',
      website: 'https://www.paxos.com/busd/',
    },
    primaryColor: '#FFC200',
    gradientColors: ['#EAEAEA', '#FFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'thorchain_bnbmainnet',
    displayName: 'THORChain',
    decimals: 8,
    ticker: 'RUNEBNB',
    displayTicker: 'RUNE',
    assetId: 'RUNE-B1A',
    tokenType: 'BEP2',
    info: {
      description:
        'RUNE is a BEP-2 token that powers THORChain, the first cross-chain DEX, by providing security, liquidity, rewards, and governance.',
      twitter: 'https://twitter.com/thorchain',
      website: 'https://thorchain.org/',
      telegram: 'https://t.me/thorchain_org',
    },
    primaryColor: '#23DCC3',
    gradientColors: ['#1E8D7E', '#23DCC3'],
    gradientCoords: { x1: '2.75%', y1: '18.76%', x2: '37.39%', y2: '18.7%' },
  },
]
